import { FormProvider, useForm } from 'react-hook-form';
import ApplyFilter from '../../../components/applyFilter';
import * as yup from 'yup';
import {
  AutoCompleteController,
  DatePickerController,
} from '../../../components';

export const formSchema = yup.object({
  status: yup.string(),
  startDate: yup.date().required('Start Date is required'),
  endDate: yup.date().required('End Date is required'),
});

export type TFilterForm = yup.InferType<typeof formSchema>;

export type TFilterProps = {
  filters: TFilterForm;
  setFilters: React.Dispatch<
    React.SetStateAction<TFilterForm>
  >;
};

export const STATUS_OPTIONS = [
  { label: 'Order invoiced', value: 'invoiced' },
  { label: 'Order dispatched', value: 'dispatched' },
  { label: 'Order delivered', value: 'delivered' },
  { label: 'Order Cancelled', value: 'cancelled' },
  { label: 'Order Returned', value: 'returned' },
  { label: 'Payment initiated', value: 'created' },
  { label: 'Payment settled', value: 'processed' },
  {
    label: 'Reversal initiated',
    value: 'reversal-initiated',
  },
  { label: 'Reversal settled', value: 'reversal-settled' },
  { label: 'All', value: '' },
];

export const Filters: React.FC<TFilterProps> = ({
  filters,
  setFilters,
}) => {
  const form = useForm<TFilterForm>({
    mode: 'onTouched',
    defaultValues: filters,
  });

  const {
    control,
    formState: { errors },
    watch,
  } = form;

  const onFilterDrawerOpen = () => {
    Object.keys(filters).forEach((key) => {
      const k = key as keyof TFilterForm;
      form.setValue(k, filters[k]);
    });
  };

  return (
    <div className="filters">
      <FormProvider {...form}>
        <ApplyFilter
          executeSubmitEvent={() =>
            setFilters({
              status: watch('status'),
              startDate: watch('startDate'),
              endDate: watch('endDate'),
            })
          }
          onFilterDrawerOpen={onFilterDrawerOpen}>
          <form className="filter-form">
            <AutoCompleteController
              label="Transaction status"
              control={control}
              name="status"
              error={errors.status?.message}
              options={STATUS_OPTIONS}
            />
            <DatePickerController
              label="Payment start Date"
              control={control}
              name="startDate"
              error={errors.startDate?.message}
              selectsStart
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
            <DatePickerController
              label="Payment end Date"
              control={control}
              name="endDate"
              error={errors.endDate?.message}
              selectsEnd
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
          </form>
        </ApplyFilter>
      </FormProvider>
    </div>
  );
};
